"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/no-extraneous-dependencies
var bignumber_js_1 = require("bignumber.js");
function formatBigInt(value, decimals) {
    if (decimals === void 0) { decimals = 18; }
    var bigVal = new bignumber_js_1.BigNumber(value.toString());
    var divisor = new bignumber_js_1.BigNumber(10).pow(decimals);
    return bigVal.div(divisor).toString();
}
exports.default = formatBigInt;
//# sourceMappingURL=formatBigInt.js.map